import {Button, Loader} from '@mantine/core'
import {useContext, useEffect, useState} from 'react'

import {checkRole} from '../../../_metronic/helpers'
import API from '../../../api/APIUrl'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {getRecords, handleInputChange} from '../../CommonFunction'
import CustomCheckInput from '../../components/CustomInput/CustomCheckInput'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import CustomTable from '../../components/CustomTable'
import InputErrorBox from '../../components/InputErrorBox'
import SubmitCancleButton from '../../components/SubmitCancelButton'
import roleContext from '../../context/roleContext'
import {RoleMasterInitialInput} from '../../data/AdminModuleDefaultData'
import {APIStatusData, SubmitAPIStatusData} from '../../data/OtherDefaultData'
import {
  RoleMasterFeatureType,
  RoleMasterInput,
  RoleMasterOutput,
} from '../../types/AdminModuleTypes'
import {InputErrorType, RoleContextValue, SubmitAPIStatusType} from '../../types/OtherTypes'
import {
  cancelSubmit,
  getFeaturesData,
  getRoleByID,
  getRoleTableHeaderData,
  handleSubmit,
  validateForm,
} from './RoleFunction'
import {Modal} from 'react-bootstrap'
import {getFeaturesByUserId} from '../../../api/AdminAPI'
import {useAuth} from '../../modules/auth'

const Role = () => {
  let roleState: RoleContextValue = useContext(roleContext)
    let {roleTableHeaderData} = getRoleTableHeaderData(!checkRole(['roles'], roleState.features))
  const [editId, setEditId] = useState<string | null>(null)
  const [showForm, setShowForm] = useState<boolean>(false)
  const [showRolePermissions, setShowRolePermissions] = useState<boolean>(false)
  const [inputError, setInputError] = useState<InputErrorType>({})
  const [submitAPIStatus, setSubmitAPIStatus] = useState<SubmitAPIStatusType>(SubmitAPIStatusData)
  const [role, setRole] = useState<RoleMasterOutput>({...APIStatusData, data: []})
  const {currentUser} = useAuth()
  const [rolePermissions, setRolePermissions] = useState<RoleMasterOutput>({
    ...APIStatusData,
    data: [],
  })
  const [features, setFeatures] = useState<RoleMasterFeatureType[]>([])
  const [inputFeatures, setInputFeatures] = useState({})
  const [formField, setFormField] = useState<RoleMasterInput>(RoleMasterInitialInput)
  const getPermissionByRoleId = (roleId: string) => {
    setShowRolePermissions(true)
    getRecords(`${API.ROLES}/${roleId}/${API.PERMISSION}`, setRolePermissions)
  }
  const getTableBody = () => {
    return role?.data?.map((obj) => {
      return (
        <tr className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`} key={obj?.id ?? '-'}>
          <td className='ms-1 d-flex justify-content-top'>
            <div className='ms-2 fw-bold'>{obj?.name ?? '-'}</div>
          </td>
          <td className='ms-3' style={{borderBottom: '1px solid'}}>
            <Button
              name='viewDetails'
              className='btn btn-icon btn-secondary btn-sm me-1 mb-1'
              onClick={() => getPermissionByRoleId(obj.id)}
              title='View Features'
            >
              <i className='fa-solid fa-list'></i>
            </Button>
            {checkRole(['roles'], roleState.features) && (
              <Button
                name='editDetails'
                className='btn btn-icon btn-light-primary btn-sm me-1 mb-1'
                onClick={() => {
                  getRoleByID(
                    obj.id,
                    formField,
                    setFormField,
                    setEditId,
                    setInputError,
                    setFeatures,
                    setInputFeatures,
                    setShowForm
                  )
                }}
                title='Edit Role'
              >
                <i className='far fa-edit'></i>
              </Button>
            )}
          </td>
        </tr>
      )
    })
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getFeaturesData(setFeatures, setInputFeatures)
      // getFeatureLevel(setFeatureLevels)
      getRecords(API.ROLES, setRole)
    }

    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className='row justify-content-center'>
      <div className='card my-4 col-12' hidden={!showForm}>
        <div className='card-header   py-0'>
          <h4 className='card-title'>{editId !== null ? 'Update' : 'Add'} Role</h4>
        </div>
        <div className='card-body py-4'>
          <div className='row'>
            <div className='fv-row mb-5 col-md-2'>
              <CustomTextInput
                label='User Role Name'
                name='roleName'
                value={formField.roleName.toUpperCase()}
                onChange={(event) =>
                  handleInputChange(event, setFormField, inputError, setInputError)
                }
                id='roleName'
                error={inputError.roleName}
              />
            </div>

            {features.length > 0 ? (
              <div className='fv-row mb-5 col-md-12'>
                <label className='fs-6 fw-semibold mb-3'>Features Access/Permission</label>
                <span className='text-danger ms-1 fs-7 fw-bold'>*</span>
                <div className='d-flex flex-wrap gap-4'>
                  {features?.map((feature) => (
                    <div key={feature.id} className='fw-semibold fs-3' style={{width: '12rem'}}>
                      <CustomCheckInput
                        label={
                          feature?.description
                            .toLowerCase() // optional: convert full string to lowercase first
                            .split(' ') // split string into words
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter
                            .join(' ') ?? ''
                        }
                        name={feature.id}
                        onChange={(e) => {
                          handleInputChange(e, setInputFeatures, {}, () => {})
                        }}
                        checked={!!inputFeatures[`${feature.id}`]}
                      />
                    </div>
                  ))}
                </div>

                <InputErrorBox Message={inputError.feature} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <SubmitCancleButton
          cancle={{
            onClick: () => {
              cancelSubmit(
                setFormField,
                setEditId,
                setInputError,
                setFeatures,
                setInputFeatures,
                setShowForm
              )
            },
          }}
          submit={{
            editid: editId,
            loading: submitAPIStatus.loading,
            onClick: () =>
              handleSubmit(
                formField,
                getRecords,
                setRole,
                setEditId,
                setFormField,
                editId,
                setInputError,
                validateForm,
                setFeatures,
                setInputFeatures,
                inputFeatures,
                setSubmitAPIStatus,
                setShowForm
              ),
          }}
        />
      </div>
      <div className='col-md-5 col-12'>
        <CustomTable
          data={role}
          setData={setRole}
          url={API.ROLES}
          tableBody={getTableBody}
          tableHeadData={roleTableHeaderData}
          tableLabel='Roles'
          newRecordButton={
            <Button
              type='button'
              className='btn btn-primary btn-sm me-3 mt-3 mb-3'
              onClick={() => setShowForm(true)}
              hidden={showForm || !checkRole(['roles'], roleState.features)}
            >
              Add Roles
            </Button>
          }
        />
      </div>
      <Modal
        show={showRolePermissions}
        onClose={() => setShowRolePermissions(false)}
        animation={false}
        backdrop='static'
        centered
      >
        {/* begin::modal header--add holiday */}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Features</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              setShowRolePermissions(false)
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12 '>
            {rolePermissions?.loading ? (
              <Loader />
            ) : rolePermissions?.error != null ? (
              <div className=' alert alert-danger'>
                <div className='alert-text font-weight-bold'>{rolePermissions?.error}</div>
              </div>
            ) : rolePermissions?.data?.length > 0 ? (
              <div className='d-flex flex-wrap gap-4'>
                {rolePermissions.data?.map((feature, index) => (
                  <div className='fw-semibold fs-5 mb-3' style={{width: '14rem'}}>
                    <span>
                      {index + 1 + '. '}
                      {feature?.name
                        ?.replaceAll('_', ' ')
                        ?.toLowerCase() // optional: convert full string to lowercase first
                        .split(' ') // split string into words
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter
                        .join(' ') ?? ''}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div className='text-center'>No Data Available</div>
            )}
          </div>
          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                setShowRolePermissions(false)
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{marginLeft: '15px'}}
            >
              Close
            </Button>
            {/* Soft refresh role context after save so feature gates update instantly */}
            {/* We piggyback on the fact that handleSubmit updates features on the backend; here we re-fetch current user's features */}
            <Button
              onClick={async () => {
                try {
                  if (!currentUser?.id) { setShowRolePermissions(false); return }
                  const res = await getFeaturesByUserId(currentUser.id)
                  if (res?.statusCode === 200) {
                    const roleName = res?.data?.[0]?.role?.name
                    const newFeatures: string[] = []
                    res?.data?.[0]?.role?.permissions?.forEach((p: any) => newFeatures.push(p?.permission?.name))
                    roleState.updateState(newFeatures, roleName)
                    sessionStorage.setItem(
                      'currentUserRole',
                      JSON.stringify({ roleName, features: newFeatures })
                    )
                  }
                } catch (e) {}
                setShowRolePermissions(false)
              }}
              type='button'
              className='btn btn-primary ms-2 btn-sm font-weight-bold'
            >
              Refresh Access
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Role
